var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.453 6.28598C11.9098 5.50754 12.1071 4.60396 12.0163 3.70598C11.882 2.36798 11.135 1.18523 9.91401 0.375977L9.08526 1.62548C9.92451 2.18198 10.4353 2.97473 10.5238 3.85598C10.5646 4.26555 10.5136 4.67907 10.3745 5.06646C10.2354 5.45386 10.0118 5.80538 9.71976 6.09548L8.82576 6.98948L10.0393 7.34573C13.2133 8.27573 13.25 11.4677 13.25 11.5H14.75C14.75 10.1582 14.033 7.53623 11.453 6.28598Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 7C7.7795 7 9.125 5.6545 9.125 4C9.125 2.3455 7.7795 1 6.125 1C4.4705 1 3.125 2.3455 3.125 4C3.125 5.6545 4.4705 7 6.125 7ZM6.125 2.5C6.95225 2.5 7.625 3.17275 7.625 4C7.625 4.82725 6.95225 5.5 6.125 5.5C5.29775 5.5 4.625 4.82725 4.625 4C4.625 3.17275 5.29775 2.5 6.125 2.5ZM7.25 7.75H5C2.51825 7.75 0.5 9.76825 0.5 12.25V13H2V12.25C2 10.5955 3.3455 9.25 5 9.25H7.25C8.9045 9.25 10.25 10.5955 10.25 12.25V13H11.75V12.25C11.75 9.76825 9.73175 7.75 7.25 7.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.bf1780c4b7f58b892b988acb069ca8dc.svg";
export { ForwardRef as ReactComponent };